module.exports = __webpack_public_path__ + "static/media/articles.d39eee95.png";